// 监控预警接口
import request from '@/utils/request'

// 分页查询监控人员列表
export const pageUserMonitoringPerson = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/userMonitoring/pageUserMonitoringPerson',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询监控企业列表
export const pageUserMonitoringUnit = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/userMonitoring/pageUserMonitoringUnit',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询用户监控设置列表
export const listUserMonitoring = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/userMonitoringConfig/listUserMonitoring',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 保存或修改用户监控设置
export const saveOrUpdateUserMonitoring = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/userMonitoringConfig/saveOrUpdateUserMonitoring',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 查询当前用户监控消息推送设置
export const getUserPushConfig = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/userMessagePush/getUserPushConfig',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 保存或修改用户监控消息推送设置
export const saveOrUpdateUserPushConfig = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/userMessagePush/saveOrUpdateUserPushConfig',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}
